import { Routes, ExtraOptions } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { LillyComponent } from "./lilly/lilly.component";
import { ImpressumComponent } from "./impressum/impressum.component";
import { SchneidereipdComponent } from "./projects/schneidereipd/schneidereipd.component";
import { VolkstheaterComponent } from "./projects/volkstheater/volkstheater.component";
import { NvtTicketsComponent } from "./projects/nvt-tickets/nvt-tickets.component";
import { BackstageComponent } from "./projects/backstage/backstage.component";


export const routes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'lilly', component: LillyComponent},
  {path: 'impressum', component: ImpressumComponent},
  {path: 'schneidereipd', component: SchneidereipdComponent},
  {path: 'volkstheater', component: VolkstheaterComponent},
  {path: 'nvt-tickets', component: NvtTicketsComponent},
  {path: 'backstage', component: BackstageComponent},
  {path: '**', redirectTo: '' }
];

export const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled'
};